import Icon from '../_HumanWritten/Icon/Icon';
import { Button } from '../Button/Button';

export interface AddOnInputCounterProps {
	amount: number;
	onAdd: () => void;
	onSubtract: () => void;
	addDisabled: boolean;
	subtractDisabled: boolean;
	addBtnAlt: string;
	subtractBtnAlt: string;
}

export function AddOnInputCounter({
	amount,
	onAdd,
	onSubtract,
	addDisabled,
	subtractDisabled,
	addBtnAlt,
	subtractBtnAlt,
}: AddOnInputCounterProps) {
	return (
		<div className="amount-controls-container">
			<Button className="amount-btn subtract" disabled={subtractDisabled} onClick={onSubtract}>
				<Icon name="remove" useMaterialIcons />
			</Button>
			<div className="amount-label-container">
				<h2 className="amount-label">{amount}</h2>
			</div>
			<Button className="amount-btn add" disabled={addDisabled} onClick={onAdd}>
				<Icon name="add" useMaterialIcons />
			</Button>
		</div>
	);
}
